/* ============================================================
   GELADI PRODUCT - section JS

   Initializes every .geladi-product section on the page (and on
   theme-editor section reload). Handles:
     - scroll-snap gallery carousel
     - mobile sticky buy bar visibility (IntersectionObserver)
     - size grid -> price / sale badges / mobile bar sync

   Money formatting uses the shop's actual money_format string,
   passed via data-money-format on the section root. Compatible
   with every currency Shopify supports.
   ============================================================ */
(function () {
  function init(section) {
    if (section.dataset.gpInit === '1') return;
    section.dataset.gpInit = '1';

    var moneyFormat = section.dataset.moneyFormat || '{{amount}}';

    // Shopify-compatible money formatter. Handles all six placeholder formats:
    //   {{amount}}                                       1,134.65
    //   {{amount_no_decimals}}                           1,135
    //   {{amount_with_comma_separator}}                  1.134,65
    //   {{amount_no_decimals_with_comma_separator}}      1.135
    //   {{amount_with_space_separator}}                  1 134,65
    //   {{amount_no_decimals_with_space_separator}}      1 135
    //   {{amount_with_apostrophe_separator}}             1'134.65
    function formatMoney(cents, format) {
      if (typeof cents === 'string') cents = cents.replace('.', '');
      var fmt = format || moneyFormat;
      var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      function formatWithDelimiters(number, precision, thousands, decimal) {
        if (precision == null) precision = 2;
        if (thousands == null) thousands = ',';
        if (decimal == null) decimal = '.';
        if (isNaN(number) || number == null) return '0';
        number = (number / 100.0).toFixed(precision);
        var parts = number.split('.');
        var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
        var centsPart = parts[1] ? (decimal + parts[1]) : '';
        return dollars + centsPart;
      }
      var match = fmt.match(placeholderRegex);
      if (!match) return fmt;
      var value;
      switch (match[1]) {
        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0); break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ','); break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ','); break;
        case 'amount_with_space_separator':
          value = formatWithDelimiters(cents, 2, ' ', ','); break;
        case 'amount_no_decimals_with_space_separator':
          value = formatWithDelimiters(cents, 0, ' ', ''); break;
        case 'amount_with_apostrophe_separator':
          value = formatWithDelimiters(cents, 2, "'", '.'); break;
        case 'amount':
        default:
          value = formatWithDelimiters(cents, 2); break;
      }
      return fmt.replace(placeholderRegex, value);
    }

    // ---- Gallery: scroll-snap carousel ----
    var thumbsList = section.querySelector('.geladi-product__thumbs');
    var slidesEl = section.querySelector('[data-slides]');
    var slides = section.querySelectorAll('[data-slide-index]');

    if (slidesEl && slides.length > 0) {
      var setActiveThumb = function (idx) {
        if (!thumbsList) return;
        var allThumbs = thumbsList.querySelectorAll('[data-thumb-index]');
        var activeThumb = null;
        allThumbs.forEach(function (t) {
          if (parseInt(t.getAttribute('data-thumb-index'), 10) === idx) {
            t.classList.add('is-active');
            activeThumb = t;
          } else {
            t.classList.remove('is-active');
          }
        });
        if (activeThumb) {
          var cRect = thumbsList.getBoundingClientRect();
          var tRect = activeThumb.getBoundingClientRect();
          var isVertical = thumbsList.clientHeight > thumbsList.clientWidth;
          if (isVertical) {
            if (tRect.top < cRect.top || tRect.bottom > cRect.bottom) {
              var ty = activeThumb.offsetTop - (thumbsList.clientHeight / 2) + (activeThumb.offsetHeight / 2);
              thumbsList.scrollTo({ top: ty, behavior: 'smooth' });
            }
          } else {
            if (tRect.left < cRect.left || tRect.right > cRect.right) {
              var tx = activeThumb.offsetLeft - (thumbsList.clientWidth / 2) + (activeThumb.offsetWidth / 2);
              thumbsList.scrollTo({ left: tx, behavior: 'smooth' });
            }
          }
        }
      };

      var scrollToSlide = function (idx) {
        var slide = slides[idx];
        if (slide) slidesEl.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
      };

      if (thumbsList) {
        thumbsList.addEventListener('click', function (e) {
          var thumb = e.target.closest('[data-thumb-index]');
          if (!thumb || !thumbsList.contains(thumb)) return;
          e.preventDefault();
          var idx = parseInt(thumb.getAttribute('data-thumb-index'), 10);
          scrollToSlide(idx);
          setActiveThumb(idx);
        });
      }

      var scrollTimer;
      slidesEl.addEventListener('scroll', function () {
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(function () {
          var idx = Math.round(slidesEl.scrollLeft / slidesEl.clientWidth);
          setActiveThumb(idx);
        }, 80);
      });

      slidesEl.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
        e.preventDefault();
        var current = Math.round(slidesEl.scrollLeft / slidesEl.clientWidth);
        var next = e.key === 'ArrowLeft'
          ? Math.max(0, current - 1)
          : Math.min(slides.length - 1, current + 1);
        scrollToSlide(next);
      });
    }

    // ---- Lightbox / zoom overlay ----
    var lightbox = section.querySelector('[data-lightbox]');
    var zoomTriggers = section.querySelectorAll('[data-zoom-trigger]');
    if (lightbox && zoomTriggers.length > 0) {
      var lbStage = lightbox.querySelector('[data-lightbox-stage]');
      // Build the image element in JS (its real dimensions come from the loaded
      // hi-res source, so there are no meaningful static width/height attrs).
      var lbImg = document.createElement('img');
      lbImg.className = 'geladi-lightbox__img';
      lbImg.setAttribute('alt', '');
      if (lbStage) lbStage.appendChild(lbImg);
      var lbCounter = lightbox.querySelector('[data-lightbox-counter]');
      var lbCloseBtn = lightbox.querySelector('.geladi-lightbox__close');
      var lbCloseEls = lightbox.querySelectorAll('[data-lightbox-close]');
      var lbPrev = lightbox.querySelector('[data-lightbox-prev]');
      var lbNext = lightbox.querySelector('[data-lightbox-next]');

      // Build the hi-res source list once from each trigger's image.
      var lbSources = [];
      zoomTriggers.forEach(function (t) {
        var img = t.querySelector('img');
        if (!img) return;
        lbSources.push({
          src: img.getAttribute('data-zoom-src') || img.currentSrc || img.src,
          alt: img.getAttribute('alt') || ''
        });
      });

      var lbIndex = 0;
      var lbLastFocused = null;

      var lbRender = function (i) {
        lbIndex = (i % lbSources.length + lbSources.length) % lbSources.length;
        lbImg.classList.remove('is-zoomed');
        lbImg.setAttribute('src', lbSources[lbIndex].src);
        lbImg.setAttribute('alt', lbSources[lbIndex].alt);
        if (lbStage) lbStage.scrollTo(0, 0);
        if (lbCounter) lbCounter.textContent = (lbIndex + 1) + ' / ' + lbSources.length;
      };

      var lbTrapFocus = function (e) {
        var focusables = lightbox.querySelectorAll('button:not([hidden])');
        if (focusables.length === 0) return;
        var first = focusables[0];
        var last = focusables[focusables.length - 1];
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      };

      var lbClose = function () {
        lightbox.setAttribute('hidden', '');
        document.documentElement.classList.remove('geladi-lightbox-open');
        document.removeEventListener('keydown', lbKey);
        if (lbLastFocused && lbLastFocused.focus) lbLastFocused.focus();
      };

      var lbKey = function (e) {
        if (e.key === 'Escape') {
          e.preventDefault();
          lbClose();
        } else if (e.key === 'ArrowLeft' && lbSources.length > 1) {
          e.preventDefault();
          lbRender(lbIndex - 1);
        } else if (e.key === 'ArrowRight' && lbSources.length > 1) {
          e.preventDefault();
          lbRender(lbIndex + 1);
        } else if (e.key === 'Tab') {
          lbTrapFocus(e);
        }
      };

      var lbOpen = function (i) {
        lbLastFocused = document.activeElement;
        lbRender(i);
        lightbox.removeAttribute('hidden');
        document.documentElement.classList.add('geladi-lightbox-open');
        if (lbCloseBtn) lbCloseBtn.focus();
        document.addEventListener('keydown', lbKey);
      };

      // Open from each trigger, but ignore the click that ends a horizontal
      // carousel swipe (touch) so swiping doesn't pop the lightbox open.
      zoomTriggers.forEach(function (t) {
        var downX = 0;
        var downY = 0;
        var moved = false;
        t.addEventListener('pointerdown', function (e) {
          downX = e.clientX;
          downY = e.clientY;
          moved = false;
        });
        t.addEventListener('pointermove', function (e) {
          if (Math.abs(e.clientX - downX) > 8 || Math.abs(e.clientY - downY) > 8) moved = true;
        });
        t.addEventListener('pointercancel', function () { moved = true; });
        t.addEventListener('click', function (e) {
          e.preventDefault();
          if (moved) return;
          lbOpen(parseInt(t.getAttribute('data-img-index'), 10) || 0);
        });
      });

      lbCloseEls.forEach(function (el) {
        el.addEventListener('click', lbClose);
      });
      if (lbPrev) lbPrev.addEventListener('click', function () { lbRender(lbIndex - 1); });
      if (lbNext) lbNext.addEventListener('click', function () { lbRender(lbIndex + 1); });

      // Clicking the dim backdrop (the overlay itself, not a child) closes.
      lightbox.addEventListener('click', function (e) {
        if (e.target === lightbox) lbClose();
      });

      // Tap/click the image toggles full-resolution zoom; scroll to pan.
      if (lbImg) {
        lbImg.addEventListener('click', function () {
          lbImg.classList.toggle('is-zoomed');
          if (lbStage && !lbImg.classList.contains('is-zoomed')) lbStage.scrollTo(0, 0);
        });
      }
    }

    // ---- Sticky buy bar visibility (mobile) ----
    var stickyBuyBar = section.querySelector('[data-sticky-buy]');
    var inPageAtc = section.querySelector('[data-add-to-cart]');
    if (stickyBuyBar && inPageAtc && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) {
          stickyBuyBar.setAttribute('data-hidden', '');
        } else {
          stickyBuyBar.removeAttribute('data-hidden');
        }
      }, { threshold: 0, rootMargin: '0px 0px -60px 0px' });
      io.observe(inPageAtc);
    }

    // ---- Size grid ----
    // Each size is a button carrying its variant id and prices (cents). The
    // hidden input[name="id"] is the form's source of truth; clicking a size
    // writes it and updates the price row, the badges and the mobile bar.
    var picker = section.querySelector('[data-size-picker]');
    var variantInput = section.querySelector('[data-variant-input]');
    if (!picker || !variantInput) return;

    var sizeButtons = picker.querySelectorAll('[data-size]');
    // Scope the price lookups to the price row: the size buttons carry
    // data-price / data-compare-price too and come first in the DOM.
    var priceRow = section.querySelector('.geladi-product__price-row');
    var priceEl = priceRow ? priceRow.querySelector('[data-price]') : null;
    var priceMeta = priceRow ? priceRow.querySelector('[data-price-meta]') : null;
    var compareEl = priceRow ? priceRow.querySelector('[data-compare-price]') : null;
    var saleBadge = section.querySelector('[data-sale-badge]');
    var submitBtn = section.querySelector('[data-add-to-cart]');
    var availableLabel = section.querySelector('[data-submit-label-available]');
    var soldoutLabel = section.querySelector('[data-submit-label-soldout]');
    var stickyPriceEl = section.querySelector('[data-sticky-price]');
    var stickyBuyBtn = section.querySelector('[data-sticky-buy-btn]');
    var stickySelect = section.querySelector('[data-sticky-variant-select]');

    var selectSize = function (btn) {
      if (!btn || btn.disabled) return;
      var price = parseInt(btn.getAttribute('data-price'), 10);
      var comparePrice = parseInt(btn.getAttribute('data-compare-price'), 10);
      var onSale = !isNaN(comparePrice) && comparePrice > price;

      sizeButtons.forEach(function (b) {
        b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
      });
      variantInput.value = btn.getAttribute('data-variant-id');

      if (priceEl && !isNaN(price)) priceEl.textContent = formatMoney(price);
      if (stickyPriceEl && !isNaN(price)) stickyPriceEl.textContent = formatMoney(price);
      if (stickySelect && stickySelect.value !== variantInput.value) {
        stickySelect.value = variantInput.value;
      }

      // Compare price, -X% and the campaign badge show only on a reduced size.
      if (priceMeta) {
        if (onSale) priceMeta.removeAttribute('hidden');
        else priceMeta.setAttribute('hidden', '');
      }
      if (onSale) {
        if (compareEl) compareEl.textContent = formatMoney(comparePrice);
        if (saleBadge) saleBadge.textContent = '-' + Math.round((comparePrice - price) / comparePrice * 100) + '%';
      }

      // Sold-out sizes are disabled buttons and can't be picked, so the
      // selected size is always available.
      if (submitBtn) {
        submitBtn.removeAttribute('disabled');
        if (availableLabel) availableLabel.removeAttribute('hidden');
        if (soldoutLabel) soldoutLabel.setAttribute('hidden', '');
      }
      if (stickyBuyBtn) stickyBuyBtn.removeAttribute('disabled');
    };

    picker.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-size]');
      if (btn && picker.contains(btn)) selectSize(btn);
    });

    // Mobile bar select → pick the matching size in the grid.
    if (stickySelect) {
      stickySelect.addEventListener('change', function () {
        if (stickySelect.value === variantInput.value) return;
        sizeButtons.forEach(function (b) {
          if (b.getAttribute('data-variant-id') === stickySelect.value) selectSize(b);
        });
      });
    }
  }

  function initAll(root) {
    (root && root.querySelectorAll ? root : document)
      .querySelectorAll('.geladi-product')
      .forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  // Re-init when Shopify theme editor reloads a section
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();
